import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto w-full max-w-[1440px] px-4 md:px-8 lg:px-12 min-h-[70vh] flex flex-col items-center justify-center text-center py-16">
      <span className="font-heading text-[100px] md:text-[160px] leading-none font-extrabold text-background-200 select-none">
        404
      </span>
      <h1 className="mt-2 font-heading text-xl md:text-3xl font-bold text-foreground-950">
        页面走丢了
      </h1>
      <p className="mt-3 text-sm md:text-base text-foreground-500">
        找不到路径 <span className="text-accent-400 font-mono">{location.pathname}</span> 对应的页面。
      </p>
      <p className="mt-2 text-sm text-foreground-500">
        可能是链接有误或内容已调整，换个地方看看吧。
      </p>
      <div className="mt-7 flex items-center gap-3 flex-wrap justify-center">
        <Link
          to="/"
          className="h-10 px-6 rounded-md bg-primary-500 hover:bg-primary-600 text-foreground-950 text-sm font-label flex items-center whitespace-nowrap transition-colors cursor-pointer"
        >
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="h-10 px-6 rounded-md border border-background-300 text-foreground-700 hover:bg-background-200 text-sm font-label flex items-center whitespace-nowrap transition-colors cursor-pointer"
        >
          浏览电影频道
        </Link>
      </div>
    </div>
  );
}